import React from 'react';
import checkCircle from '../../../assets/images/check-circle.svg';
import errorCheckCircle from '../../../assets/images/error-check-circle.svg';
import css from './ToastNotification.module.scss';

const ToastNotification = ({ message, show,type }) => {
  if (!show) return null;

  const icon = type === "error" ? errorCheckCircle : checkCircle;

  return (
    <div className={css.toastNotification}>
      <img src={icon} alt="Status Icon" className={css.toastIcon} />
      <span className={css.toastMsg}>{message}</span>
    </div>
  );
};

export default ToastNotification;